// extracted by mini-css-extract-plugin
module.exports = {"root":"_453e9e","border":"_3438e6","image":"_da32e9","title":"_b2424d","content":"_fd892a","footer":"_691e50"};